jQuery(document).ready(function($) {

	//Add loading icon to some store buttons on click
	function cs711loading() {
		var $button = $(this);
		if (!$button.hasClass('disabled')) {
			$(this).addClass('-is-loading');
		}
	}
	$('form.cart button').click(cs711loading);
	$('#go-to-checkout').click(cs711loading);
	$('#place_order').click(cs711loading);
	$('.woocommerce-message .wc-forward').click(cs711loading);

	//Show checkout login form popup
	$(function() {
		var $checkout_login			=	$('#checkout-login');
		var $checkout_login_form	=	$('#checkout-login-form');

		$checkout_login.click(function(e)  {
			$(this).toggleClass('-is-active');
			$checkout_login_form.toggleClass('-is-visible');
			e.stopPropagation();
		});

		$checkout_login_form.click(function(e)  {
			e.stopPropagation();
		});

		$(document).click(function() {
			$checkout_login_form.removeClass('-is-visible');
			$checkout_login.removeClass('-is-active');
		});
	});

	//Manage delete account dialog
	//Show/Hide mobile menu (slide down)
	$(function() {
		var $detele_account_button			=	$('#delete-button-dialog');
		var $close_delete_account 	=	$('#close-delete-button-dialog');
		var $delete_account_dialog 	=	$('#delete-acount-overlay');

		$detele_account_button.click(function()  {
			$delete_account_dialog.toggleClass('-is-visible');
		});

		$close_delete_account.click(function()  {
			$delete_account_dialog.toggleClass('-is-visible');
		});
	});
});
